<template>
    <div class="loading-pop show" style="z-index: 9999999;">
        <svg viewBox="25 25 50 50">
            <circle r="20" cy="50" cx="50"></circle>
        </svg>
    </div>
</template>